import { useState } from "react";
import InterfaceTable from "../../Table/InterfaceTable";
import moment from "moment";

const EventsBoard = ({ events, loading }) => {
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });

  const safeEvents = Array.isArray(events) ? events : [];

  const columnsEvents = [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Fecha inicial",
      dataIndex: "start_date",
      key: "start_date",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "Fecha final",
      dataIndex: "final_date",
      key: "final_date",
      render: (date) => (date ? moment(date).format("DD/MM/YYYY") : "-"),
    },
    {
      title: "País",
      dataIndex: "country",
      key: "country",
    },
  ];

  const handlePageChange = (pagination) => {
    const { current = 1, pageSize = values.limit } = pagination;
    setValues({
      page: current - 1,
      limit: pageSize,
    });
  };

  const paginatedEvents = safeEvents.slice(
    values.page * values.limit,
    (values.page + 1) * values.limit
  );

  return (
    <InterfaceTable
      rowKey="id"
      data={paginatedEvents}
      columns={columnsEvents}
      loading={loading}
      onChange={handlePageChange}
      pagination={{
        current: values.page + 1,
        pageSize: values.limit,
        total: safeEvents.length,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
      }}
    />
  );
};

export default EventsBoard;
